import React from 'react'
import { Svg } from './styles'

const Loader = ({
  size = 'm'
}) =>
  <Svg
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    size={size}
    vectorEffect="non-scaling-stroke">
      <circle cx="50" cy="50" r="49"/>
      <circle cx="50" cy="50" r="49"/>
  </Svg>

export default Loader


// WEBPACK FOOTER //
// ./src/Loader/index.js